import { render, staticRenderFns } from "./OverviewSection.vue?vue&type=template&id=53a4a36f&scoped=true&"
import script from "./OverviewSection.vue?vue&type=script&lang=js&"
export * from "./OverviewSection.vue?vue&type=script&lang=js&"
import style0 from "./OverviewSection.vue?vue&type=style&index=0&id=53a4a36f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53a4a36f",
  null
  
)

export default component.exports